import { menu } from "../config/constant";
import { triggerGaEvents } from './gtag';

export default function Menu() {

  const renderMenuItems = (items, isSub = false) => {
    return items.map((item) => {
      const hasMenu = Array.isArray(item.menu) && item.menu.length > 0;

      return (
        <li key={item.label} className={`rounded-sm h-[34px] flex items-center font-medium text-xs hover:bg-gray-100 ${hasMenu ? "relative" : ""}`}>
          <button onClick={(e) => {
            e.stopPropagation();
            const url = item.url();
            if (url && !item.disable) {
              triggerGaEvents('menu_click', { event_category: 'Navigation', event_label: item.label, item_url: url });
              window.open(url, '_blank');
            }
          }}
            className={`w-full h-full px-3 py-1 text-left flex items-center outline-none focus:outline-none ${item?.disable ? "cursor-not-allowed" : "cursor-pointer"}`}>
            <span className="pr-1 flex flex-1 items-center">
              {item.icon && (<img className="mr-2 h-[17px] w-[17px] text-[14px]" src={item.icon} alt="Menu Icon" />)}
              {item.label}
            </span>
            {hasMenu && (
              <span className="mr-auto">
                <svg className="fill-current h-4 w-4 transition duration-150 ease-in-out" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                  <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                </svg>
              </span>
            )}
          </button>
          {!item.disable && hasMenu && (
            <ul className="bg-white border rounded-sm absolute top-0 right-0 min-w-60 origin-top-left transition duration-75 ease-in-out">
              {renderMenuItems(item.menu, true)}
            </ul>
          )}
        </li>
      );
    });
  };

  return (
    <div className="group inline-block dropdown-menu z-[100]">
      <button aria-haspopup="true" aria-controls="menu-main" className="outline-none focus:outline-none px-3 py-1 bg-white rounded-sm flex items-center mr-2">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="rgba(217,35,45,1)">
          <path d="M3 4H21V6H3V4ZM3 11H15V13H3V11ZM3 18H21V20H3V18Z" />
        </svg>
      </button>

      <ul className="bg-[#EFEFF4] py-[10px] border-r border-[#C4C4C4] rounded-sm transform scale-0 group-hover:scale-100 absolute transition duration-75 ease-in-out origin-top z-[1000] w-[309px]">
        {renderMenuItems(menu)}
        <li className="rounded-sm h-[34px] flex items-center font-medium text-xs hover:bg-gray-100 relative">
          <button className="w-full h-full px-3 py-1 text-left flex items-center justify-between outline-none focus:outline-none group hover:bg-gray-100 transition">
            <span className="flex items-center gap-2">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-4 h-4 text-gray-600 transform transition-transform duration-200 ease-in-out group-hover:rotate-0">
                <path strokeLinecap="round" strokeLinejoin="round" d="M12 18h.01M12 14a4 4 0 10-4-4m4 0v.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              <span className="pr-1 flex flex-1 items-center">HELP</span>
            </span>
            <svg className="fill-current h-4 w-4 transition duration-150 ease-in-out" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
              <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
            </svg>
          </button>

          <ul className="bg-white border rounded-sm absolute top-0 right-0 min-w-60 origin-top-left transition duration-75 ease-in-out">
            <li className="px-4 py-2 hover:bg-gray-100 border-b">
              <a
                href="https://moglilabs.freshservice.com/support/home"
                target="_blank"
                rel="noopener noreferrer"
                title="Freshservice Support"
                className="block text-[14px] text-blue-600 hover:underline truncate"
              >
                Freshservice Support
              </a>

              <a
                href="mailto:moglix-support@moglix.com"
                title="moglix-support@moglix.com"
                className="flex items-center gap-1 text-[12px] text-[#696969]"
              >
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-4 h-4 text-gray-500 shrink-0" >
                  <path strokeLinecap="round" strokeLinejoin="round" d="M3 8.25L12 13.5l9-5.25M4.5 6h15a1.5 1.5 0 011.5 1.5v9a1.5 1.5 0 01-1.5 1.5h-15A1.5 1.5 0 013 16.5v-9A1.5 1.5 0 014.5 6z" />
                </svg>
                <span className="truncate">moglix-support@moglix.com</span>
              </a>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  );
}
